import React, { useState } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionIndustryChallenge = (props) => {
  const { t } = useTranslation();
  const { challenges } = props;

  return (
    <section className="solution-industry-challenge">
      <div className="inner">
        <Title title={t("solution.detail.title-challenge")} align="left" />
        <div className="content-warp">
          {challenges?.map((challenge, index) => (
            <div key={index} className="card">
              <div className="card-icon">
                <i className={challenge.icon}></i>
              </div>
              <div className="card-content">
                <div className="card-title">{challenge.title}</div>
                <div className="card-text">{challenge.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
